import { IEditPortionContext } from './editPortionContext';

export enum EditPortionActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	CHANGE_NAME_OF_PORTION = 'CHANGE_NAME_OF_PORTION',
	CHANGE_PRICE = 'CHANGE_PRICE',
	CHANGE_PRICE_STRATEGY = 'CHANGE_PRICE_STRATEGY',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	TOGGLE_IS_PROTECT_FROM_SYNC = 'TOGGLE_IS_PROTECT_FROM_SYNC',
	TOGGLE_IS_DISABLED = 'TOGGLE_IS_DISABLED',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetInitialFormData {
	type: EditPortionActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		portionId: IEditPortionContext['portionId'];
		nameOfPortion: IEditPortionContext['nameOfPortion'];
		price: IEditPortionContext['price'];
		priceStrategy: IEditPortionContext['priceStrategy'];
		externalId: IEditPortionContext['externalId'];
		isProtectedFromSync: IEditPortionContext['isProtectedFromSync'];
		isDisabled: IEditPortionContext['isDisabled'];
		posName: IEditPortionContext['posName'];
		articleNumber: IEditPortionContext['articleNumber'];
		fetchedCustomers: IEditPortionContext['fetchedCustomers'];
		IDSelectedCustomer: IEditPortionContext['IDSelectedCustomer'];
		fetchedRestaurants: IEditPortionContext['fetchedRestaurants'];
		IDSelectedRestaurant: IEditPortionContext['IDSelectedRestaurant'];
		nameOfDish: IEditPortionContext['nameOfDish'];
		dishId: IEditPortionContext['dishId'];
		isCreatedOnPos: IEditPortionContext['isCreatedOnPos'];
		defaultCustomerLanguage: IEditPortionContext['defaultCustomerLanguage'];
		translations: IEditPortionContext['translations'];
	};
}

interface IChangeNameOfPortion {
	type: EditPortionActionTypes.CHANGE_NAME_OF_PORTION;
	payload: {
		nameOfPortion: IEditPortionContext['nameOfPortion'];
	};
}

interface IChangePrice {
	type: EditPortionActionTypes.CHANGE_PRICE;
	payload: {
		price: IEditPortionContext['price'];
	};
}

interface IChangePriceStrategy {
	type: EditPortionActionTypes.CHANGE_PRICE_STRATEGY;
	payload: {
		priceStrategy: IEditPortionContext['priceStrategy'];
	};
}

interface IChangeExternalId {
	type: EditPortionActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: IEditPortionContext['externalId'];
	};
}

interface IToggleIsTaxPercentProtectedFromSync {
	type: EditPortionActionTypes.TOGGLE_IS_PROTECT_FROM_SYNC;
}

interface IToggleIsDisabled {
	type: EditPortionActionTypes.TOGGLE_IS_DISABLED;
}

interface ISetTranslationTab {
	type: EditPortionActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IEditPortionContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: EditPortionActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IEditPortionContext['translations'];
	};
}

interface ISetAdditionalRestaurants {
	type: EditPortionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		selectedAdditionalRestaurants: IEditPortionContext['selectedAdditionalRestaurants'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditPortionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditPortionContext['typeOfModalWindow'];
	};
}

export type TEditPortionAction =
	| ISetInitialFormData
	| IChangeNameOfPortion
	| IChangePrice
	| IChangePriceStrategy
	| IChangeExternalId
	| IToggleIsTaxPercentProtectedFromSync
	| IToggleIsDisabled
	| ISetTranslationTab
	| IChangeTranslation
	| ISetAdditionalRestaurants
	| IChangeTypeOfModalWindow;
